import JsBarcode from 'jsbarcode'

export default {
    methods: {
        print() {
            return {
                carteirinha(cidadao) {
                    const canvas = document.createElement('canvas')

                    JsBarcode(canvas, cidadao.cpf_numero, {
                        displayValue: false,
                        fontSize: 12,
                        format: "CODE39",
                        height: 30,
                        margin: 0,
                        marginBottom: 5,
                        marginTop: 2,
                        width: 1.5,
                    })

                    const page = window.open('', Math.random())
                
                    page.document.write(`
                        <head>
                            <title>Carteirinha</title>
                
                            <style>
                                * {
                                    font-family: 'Arial Black', 'Arial Bold', Gadget, sans-serif;
                                }
                                .content {
                                    align-items: center;
                                    display: flex;
                                    flex-direction: column;
                                    width: 100%;
                                }
                                .paper {
                                    width: 8.3cm;
                                }
                                .container {
                                    display: flex;
                                    flex-direction: column;
                                    padding: 0 0.1cm;
                                }
                                #header {
                                    align-items: center;
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                }
                                #barcode {
                                    align-items: center;
                                    display: flex;
                                    flex-direction: column;
                                }
                                #left-col {
                                    width: 65%;
                                }
                                #right-col {
                                    font-size: 0.3cm;
                                    text-align: right;
                                    width: 35%;
                                }
                                h1 {
                                    background-color: #000000;
                                    color: #FFFFFF;
                                    font-size: 0.25cm;
                                    margin: 0;
                                    padding: 0.05cm;
                                    text-align: center;
                                }
                                p {
                                    font-size: 0.25cm;
                                    margin: 0.05cm 0;
                                    padding: 0;
                                }
                            </style>
                        </head>
                
                        <body>
                            <div class="content">
                                <div class="paper">
                                    <h1>${cidadao.nome}</h1>
                                    
                                    <div class="container">
                                        <div id="header">
                                            <div id="left-col">
                                                <p>DATA NASCIMENTO: ${cidadao.nascimento}</p>
                                                <p>MUN. RESID.: ${cidadao.municipio}</p>
                                                <p>DATA DE EMISSÃO: ${cidadao.data_atual}</p>
                                            </div>

                                            <div id="right-col">
                                                ${cidadao.cpf ? cidadao.cpf : ''}
                                            </div>
                                        </div>

                                        <div id="barcode"></div>
                                    </div>
                                </div>
                            </div>
                        </body>
                    `)

                    if (cidadao.cpf) {
                        page.document.getElementById('barcode').appendChild(canvas)
                    }
                
                    page.print()
                    page.close()
                },
            }
        }
    },
}